import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getHomePath } from '../../utils/permissions';
import LoadingSpinner from '../LoadingSpinner';
import LandingPage from '../../pages/LandingPage';

/**
 * RootRedirect - Smart redirect component for the root path
 * Authenticated users are redirected to their appropriate dashboard.
 * Unauthenticated users see the marketing landing page.
 */
export const RootRedirect = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated && user) {
    // Redirect to appropriate dashboard based on tier
    const homePath = getHomePath(user);
    return <Navigate to={homePath} replace />;
  }

  // Not authenticated - show marketing landing page
  return <LandingPage />;
};

export default RootRedirect;
